var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRedDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.711,
    height: 10,
    viewBox: "0 0 10.711 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.665 0.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 10,
    height: 10,
    transform: "translate(-0.31 -0.31)",
    fill: "#d83236",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0 2.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_90da8da7-a3b6-4c60-8fa2-b4186332fd8d",
    "data-name": "90da8da7-a3b6-4c60-8fa2-b4186332fd8d",
    d: "M14.69,20.355a.663.663,0,0,1-.47-.195L9.53,15.47a.665.665,0,0,1,.94-.94l4.22,4.22,4.22-4.22a.665.665,0,0,1,.94.94l-4.69,4.69A.663.663,0,0,1,14.69,20.355Z",
    transform: "translate(-10 -15)",
    fill: "#d83236"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRedDown);
export default __webpack_public_path__ + "static/media/ic_arrow_red_down.f6a5b0dbe6a7eda7fccdc3a08d2b817e.svg";
export { ForwardRef as ReactComponent };